export interface FaqAccordionControllerData {
  resource: 'breeder' | 'buyer';
}

export interface FaqAccordionControllerProps extends FaqAccordionControllerData {}
